export default __webpack_public_path__ + "resources/icons/n220-0e6a.webp";